<div class="survey-preview-container">
  <!-- Horizontal Preview -->
  <div class="hrz-preview">
    <div class="preview-floating-options">
      <div class="responsive-option-wrapper">
        <span class="preview-container desktop-bg" id="vr_web" title="Desktop" (click)="loadViewPort('web')"></span>

        <span class="preview-container tablet-bg" title="Tablet" id="vr_tablet" (click)="loadViewPort('tablet')"></span>

        <span class="preview-container mobile-bg" title="Mobile" id="vr_mobile" (click)="loadViewPort('mobile')"></span>
      </div>
    </div>
  </div>

  <!-- Device Wrapper for Viewport Functionality -->
  <div id="deviceWrapper" class="preview--web">
    <!-- Main Form Structure matching participation.component.html -->
    <div id="previewViewport">
      <form id="surveyFrom" name="form" #f="ngForm" (keydown.enter)="preventEvent($event)" autocomplete="off" [ngClass]="{
        'mobile-wrapper': isMobile,
        'tablet-wrapper': isTablet,
        'preview-bg-color': true,
        verticalSpacing: true,
        isTopBarSticky: false
      }" novalidate>
        <div class="bg-overlay"></div>

        <!-- Survey Content Container with consistent width classes -->
        <div class="survey-content-container" [ngClass]="getSurveyWidthClasses()">
          <!-- Survey Header - Always show for preview -->
          <div class="survey-header">
            <h1 class="survey-title">{{ surveyData?.SurveyTitle || 'Survey Preview' }}</h1>
          </div>

          <!-- Welcome Page using DescriptiveTextComponent -->
          <div *ngIf="showWelcome" class="welcome-page">
            <div class="welcome-content">
              <div class="welcome-text" [innerHTML]="surveyData?.WelcomeText || 'Welcome to the survey!'"></div>

              <div class="start-survey-section">
                <button class="btn-start-survey" (click)="startSurvey()">
                  {{ surveyMessages.Continue1 }}
                </button>
              </div>
            </div>
          </div>

          <!-- Questions Page -->
          <div *ngIf="showQuestions" class="questions-page">
            <!-- Progress Bar -->
            <div class="progress-container">
              <div class="progress-bar">
                <div class="progress-fill" [style.width.%]="getProgressPercentage()"></div>
              </div>
              <div class="progress-text">
                {{ surveyMessages.page }} {{ currentPageIndex + 1 }} {{ surveyMessages.of1 }} {{
                surveyData?.Pages.length }}
              </div>
            </div>

            <!-- Page Header -->
            <div class="page-header">
              <h2 class="page-title">{{ currentPage?.PageName }}</h2>
              <div class="page-number">Page {{ currentPage?.PageNo }}</div>
            </div>

            <!-- Questions Wrapper matching participation.component.html structure -->
            <div class="questions-wrapper" id="questionWrapper" role="main">
              <div class="main-ques-cont">
                <div *ngFor="let question of currentPage?.Questions; let i = index" class="question-item">
                  <!-- Question Content based on type -->
                  <div class="question-content"
                    *ngIf="convertedQuestions.length > 0 && getConvertedQuestion(question.QNo)">
                    <!-- Text Box Questions -->
                    <app-text-box *ngIf="question.QuestionType === 'Text Box'"
                      [JsonData]="getConvertedQuestionJson(question.QNo)" [isMobile]="isMobile" [isGrid]="false"
                      [isMandatoryUpfront]="false" [isDisplayQno]="true" [isDisplaySubQno]="false">
                    </app-text-box>

                    <!-- Multiple Text Box Questions (including Attachment and Signature) -->
                    <app-multiple-text-box
                      *ngIf="question.QuestionType === 'Multiple Text Box' || question.QuestionType === 'Attachment' || question.QuestionType === 'Signature'"
                      [JsonData]="getConvertedQuestionJson(question.QNo)" [isDisplayQno]="true"
                      [isMandatoryUpfront]="false" [isSubmitted]="false" [isMobile]="isMobile"
                      [isNewParticipationButton]="true" [group]="getConvertedQuestion(question.QNo) | getgrouppreview"
                      [matrix]="(getConvertedQuestion(question.QNo) | getgrouppreview) | getmatrixpreview"
                      [isSignatureControl]="question.QuestionType === 'Signature'">
                    </app-multiple-text-box>

                    <!-- Rating Scale Questions (includes Rating Smiley, NPS, Rating Slider) -->
                    <app-rating-scale
                      *ngIf="question.QuestionType === 'Rating Smiley' || question.QuestionType === 'NPS' || question.QuestionType === 'Rating Slider'"
                      [JsonData]="getConvertedQuestionJson(question.QNo)" [isMobile]="isMobile" [isGrid]="false"
                      [isMandatoryUpfront]="false" [isDisplayQno]="true" [isDisplaySubQno]="true">
                    </app-rating-scale>

                    <!-- Grid Questions -->
                    <app-grid-questions
                      *ngIf="(question.QuestionType === 'Grid' || question.QuestionType === 'Grid Questions' || question.QuestionType === 'Grid Checkbox' || question.QuestionType === 'Single Response Grid' || question.QuestionType === 'Single Choice Grid' || question.QuestionType === 'Rating Grid') && getConvertedQuestion(question.QNo)"
                      [JsonData]="getConvertedQuestionJson(question.QNo)" [isMobile]="isMobile"
                      [isMandatoryUpfront]="false" [isDisplayQno]="true" [isSubmitted]="false"
                      [group]="getConvertedQuestion(question.QNo) | getgrouppreview"
                      [matrix]="(getConvertedQuestion(question.QNo) | getgrouppreview) | getmatrixpreview"
                      [isNewParticipationButton]="true">
                    </app-grid-questions>

                    <!-- Matrix Questions -->
                    <app-matrix-grid
                      *ngIf="(question.QuestionType === 'Matrix Grid' || question.QuestionType === 'Rating Matrix' || question.QuestionType === 'Rating Grid Matrix') && getConvertedQuestion(question.QNo)"
                      [JsonData]="getConvertedQuestionJson(question.QNo)" [isMobile]="isMobile"
                      [isMandatoryUpfront]="false" [isDisplayQno]="true" [isSubmitted]="false"
                      [groups]="[getConvertedQuestion(question.QNo) | getgrouppreview]"
                      [matrix]="(getConvertedQuestion(question.QNo) | getgrouppreview) | getmatrixpreview"
                      [DropDown]="surveyMessages.DropDown || '--Select--'" [isNewParticipationButton]="true">
                    </app-matrix-grid>

                    <!-- Radio Button Questions (including Horizontal Radio Button, Rating Radio Button) -->
                    <app-radio-button
                      *ngIf="question.QuestionType === 'Radio Button' || question.QuestionType === 'Horizontal Radio Button' || question.QuestionType === 'Rating Radio Button'"
                      [JsonData]="getConvertedQuestionJson(question.QNo)" [isMobile]="isMobile" [isGrid]="false"
                      [isMandatoryUpfront]="false" [isDisplayQno]="true" [isDisplaySubQno]="false">
                    </app-radio-button>

                    <!-- Check Box Questions (including Checkbox) -->
                    <app-check-box *ngIf="question.QuestionType === 'Check Box' || question.QuestionType === 'Checkbox'"
                      [JsonData]="getConvertedQuestionJson(question.QNo)" [isMobile]="isMobile" [isGrid]="false"
                      [isMandatoryUpfront]="false" [isDisplayQno]="true" [isDisplaySubQno]="false">
                    </app-check-box>

                    <!-- Drop Down Questions (including Drop-down) -->
                    <app-drop-down
                      *ngIf="question.QuestionType === 'Drop Down' || question.QuestionType === 'Drop-down'"
                      [JsonData]="getConvertedQuestionJson(question.QNo)" [isDisplayQno]="true"
                      [isMandatoryUpfront]="false" [isDisplaySubQno]="false" [isMDD]="false" [isNonSearchable]="false"
                      [DropDown]="surveyMessages.DropDown || '--Select--'" [isMobile]="isMobile"
                      [isNewParticipationButton]="true">
                    </app-drop-down>

                    <!-- Fallback for unrecognized question types -->
                    <div
                      *ngIf="!['Text Box', 'Multiple Text Box', 'Attachment', 'Signature', 'Rating Smiley', 'NPS', 'Rating Slider', 'Grid', 'Radio Button', 'Horizontal Radio Button', 'Rating Radio Button', 'Check Box', 'Checkbox', 'Drop Down', 'Drop-down', 'Rating Scale'].includes(question.QuestionType)"
                      class="fallback-question">
                      <input type="text" class="text-input" placeholder="Enter your answer here..." readonly>
                      <small class="fallback-note">Question type: {{ question.QuestionType || 'Unknown' }}</small>
                    </div>
                  </div>

                  <!-- Loading state when questions are not yet converted -->
                  <div class="question-content"
                    *ngIf="convertedQuestions.length === 0 || !getConvertedQuestion(question.QNo)">
                    <div class="loading-questions">
                      <small>Loading question components...</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Thank You Page using DescriptiveTextComponent -->
          <div *ngIf="showThankYou" class="thank-you-page">
            <div class="thank-you-content">
              <div class="thank-you-text"
                [innerHTML]="surveyData?.ThankYouPage || 'Thank you for completing the survey!'"></div>

              <div class="thank-you-actions">
                <button class="btn-restart-survey" (click)="restartSurvey()">
                  Restart Survey
                </button>
              </div>
            </div>
          </div>

          <!-- Navigation Band matching participation.component.html structure -->
          <div *ngIf="showQuestions" role="navigation" class="navigation-band">
            <div class="mobile-progress-bar" *ngIf="
              surveyData?.Pages?.length > 1 &&
              currentPageIndex > 0 &&
              isMobile
            ">
              <div class="progress-bar">
                <div class="progress-fill" [style.width.%]="getProgressPercentage()"></div>
              </div>
            </div>

            <div [ngStyle]="defaultBtnAlignWidth()" [style.justify-content]="'center'" [ngClass]="{
              'full-survey-width-footer': !isMobile,
              'medium-survey-width-footer': !isMobile,
              'small-survey-width-footer': !isMobile,
              noBackBtnShow: currentPageIndex === 0,
              BackBtnVisible: currentPageIndex !== 0,
              'btn-type-text': true,
              'btn-style-filled': true,
              'btn-size-md': true,
              'btn-position-center': true
            }" class="tblPageFooter footerBtnSyled">
              <!-- Back Button -->
              <div class="navigation-btns-wrapper btn-align-mar back-button-wrap" *ngIf="currentPageIndex > 0">
                <button type="button" class="back-button" (click)="previousPage()" [ngClass]="{
                  'btn-shape-curved': true
                }" aria-label="Back">
                  <span class="footer-btn-text" *ngIf="!isMobile">Back</span>
                  <ng-container *ngIf="isMobile">
                    <span class="btn-next-mob">
                      <span class="back-btn-icon"></span>
                    </span>
                  </ng-container>
                </button>
              </div>

              <!-- Next/Submit Button -->
              <div *ngIf="currentPageIndex < surveyData?.Pages?.length - 1"
                class="navigation-btns-wrapper btn-align-mar" [ngClass]="{
                'next-button-wrap': true
              }">
                <button type="button" class="next-button" (click)="nextPage()" [ngClass]="{
                  'btn-shape-curved': true
                }" aria-label="Next">
                  <span class="footer-btn-text" *ngIf="!isMobile">Next</span>
                  <ng-container *ngIf="isMobile">
                    <span class="btn-next-mob">
                      <span class="next-btn-icon"></span>
                    </span>
                  </ng-container>
                </button>
              </div>

              <!-- Submit Button -->
              <div *ngIf="currentPageIndex === surveyData?.Pages?.length - 1"
                class="navigation-btns-wrapper btn-align-mar submit-btn-wrap"
                [ngClass]="isMobile ? 'submit-btn-mobile-wrap' : ''">
                <button type="button" class="submit-button" (click)="submitSurvey()" [ngClass]="{
                  'btn-shape-curved': true
                }" aria-label="Submit">
                  <span class="footer-btn-text" *ngIf="!isMobile">Submit</span>
                  <ng-container *ngIf="isMobile">
                    <span class="btn-next-mob">
                      <span class="submit-btn-icon"></span>
                    </span>
                  </ng-container>
                </button>
              </div>
            </div>
          </div>

          <!-- Survey Footer - Always show for preview -->
          <div class="survey-footer">
            <div class="footer-content">
              <div class="footer-text">Survey Preview - Thank you for your feedback!</div>
              <div class="footer-info">This is a preview of your survey</div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>